<template>
  <div class="app-dashboard">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card
          class="overflow-hidden"
          card-background="primary"
          content-color="#fff"
        >
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <small class="flex cursor-pointer">
                <span>- 30 jours</span>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
              </small>
              <div class="truncate">
                <h2 class="mb-1 font-bold text-white">
                  {{ affiche.requestTotal }}
                </h2>
                <span>Demandes</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card
          class="overflow-hidden"
          card-background="success"
          content-color="white"
        >
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <small class="flex cursor-pointer">
                <span>- 30 jours</span>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
              </small>
              <div class="truncate">
                <h2 class="mb-1 font-bold text-white">
                  {{ affiche.requestTotalTreat }}
                </h2>
                <!--<span>Demandes clôturées</span>-->
                <span>Demandes traitées</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card class="overflow-hidden">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <small class="flex cursor-pointer">
                <span>- 30 jours</span>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
              </small>
              <div class="truncate">
                <h2 class="mb-1 font-bold">
                  {{ affiche.requestTotalOnTreat }}
                </h2>
                <span>En cours de traitement</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card
          class="overflow-hidden"
          card-background="danger"
          content-color="white"
        >
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <small class="flex cursor-pointer">
                <span>- 30 jours</span>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
              </small>
              <div class="truncate">
                <h2 class="mb-1 font-bold text-white">
                  {{ affiche.requestTotalReject }}
                </h2>
                <span>Demandes rejetées</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card
          class="overflow-hidden"
          card-background="warning"
          content-color="white"
        >
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <small class="flex cursor-pointer">
                <span>- 30 jours</span>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
              </small>
              <div class="truncate">
                <h2 class="mb-1 font-bold text-white">
                  {{ affiche.requestTotalInPause }}
                </h2>
                <span>Demandes en pause</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <br />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Demandes dont le SLA arrive à terme">
          <div slot="no-body" class="mt-4">
            <vs-table :data="slaEndRequests" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>N°</vs-th>
                <vs-th>DEMANDE</vs-th>
                <vs-th>TYPE</vs-th>
                <vs-th>PRIORITÉ</vs-th>
                <vs-th>STATUT</vs-th>
                <vs-th>DATE DE CREATION</vs-th>
                <vs-th>ACTIONS</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{ data[indextr].ref }}</span>
                  </vs-td>
                  <vs-td>
                    <span>{{ data[indextr].title }}</span>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.type }}</span></vs-td
                  >
                  <vs-td>
                    <vs-chip :color="getPriorityColor(tr.priority)">{{
                      tr.priority
                    }}</vs-chip>
                  </vs-td>
                  <vs-td>
                    <vs-chip>{{ tr.status }}</vs-chip>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.created_at }}</span></vs-td
                  >
                  <vs-td class="whitespace-no-wrap">
                    <div class="flex" @click="goToSingle(tr.id, tr.has_proved)">
                      <feather-icon
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        class="mr-2"
                      />
                      Détails
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              v-if="last_page && page"
              :total="last_page"
              v-model="page"
            ></vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <br /><br />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Etat des assignations par agent">
          <div slot="no-body" class="mt-4">
            <vs-table :data="agents" class="table-dark-inverted">
              <template slot="thead">
                <vs-th width="30%">Nom de l'agent</vs-th>
                <vs-th width="20%">Total assigné</vs-th>
                <vs-th width="20%">Total en cours</vs-th>
                <vs-th width="20%">Total traité</vs-th>
                <vs-th width="20%">Total en pause</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>{{ tr.name }}</span>
                  </vs-td>
                  <vs-td
                    ><span>{{ tr.total }}</span></vs-td
                  >
                  <vs-td
                    ><span>{{ tr.inProgress }}</span></vs-td
                  >
                  <vs-td
                    ><span>{{ tr.treat }}</span></vs-td
                  >
                  <vs-td
                    ><span>{{ tr.inPause }}</span></vs-td
                  >
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from "../../../helpers/helper";
var base_self;

// import VueApexCharts from 'vue-apexcharts';
export default {
  // components: {VueApexCharts},
  data() {
    return {
      affiche: {
        requestTotal: 0,
        requestTotalEnd: 0,
        requestTotalOnTreat: 0,
        requestTotalReject: 0,
        requestTotalTreat: 0,
      },
      agents: [],
      timeCharts: {
        options: {
          labels: [
            "= temps recommandé",
            "> au temps recommandé",
            "< au temps recommandé",
          ],
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          chart: {
            type: "pie",
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            width: 5,
          },
          colors: ["#077a30", "#EA5455", "#29c76f"],
        },
        series: [42, 17, 30],
      },
      slaEndRequests: [],
      last_page: 1,
      page: 1,
    };
  },
  watch: {
    page(value) {
      this.get_dashboard_admin_sla_end_request(value);
    },
  },
  methods: {
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(2000);
    },
    getPriorityColor(priority) {
      if (priority === "high") return "danger";
      if (priority === "low") return "success";
      if (priority === "medium") return "primary";
      return "primary";
    },
    async get_dashboard_dispatcher_request_stats() {
      let response = await base_self.$store.state.dashboard_dispatcher_request(
        {}
      );

      base_self.affiche.requestTotal = response.data.requestTotal;
      base_self.affiche.requestTotalEnd = response.data.requestTotalEnd;
      base_self.affiche.requestTotalOnTreat = response.data.requestTotalOnTreat;
      base_self.affiche.requestTotalReject = response.data.requestTotalReject;
      base_self.affiche.requestTotalTreat = response.data.requestTotalTreat;
      base_self.affiche.requestTotalInPause = response.data.requestTotalInPause;
      // console.log('dashboard_admin_request_stats -- response.data: ', response.data);
    },
    getAgent() {
      this.$vs.loading();
      this.$http
        .get("/dashboard/dispatcher/request")
        .then((response) => {
          this.$vs.loading.close();
          this.agents = response.data;
        })
        .catch((error) => {
          this.$vs.loading.close()(error.response.status === 401)
            ? window.GETCCMT.$router.push("/login")
            : console.log("error: ", error);
        });
    },
    async get_dashboard_admin_sla_end_request() {
      this.$vs.loading();
      let params = {
        page: this.page,
      };
      this.$http
        .get("/dashboard/dispatcher/request-sla-end" + _buildQuery(params), {})
        .then((response) => {
          if (response.data) {
            this.slaEndRequests = response.data.data;
            this.last_page = response.data.last_page;
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          error.response.status === 401
            ? window.GETCCMT.$router.push("/login")
            : console.log("error: ", error);
        });
    },
  },
  mounted() {
    this.getAgent();
    base_self.get_dashboard_dispatcher_request_stats();
    base_self.get_dashboard_admin_sla_end_request();
  },
  created() {
    base_self = this;
    window.AdminDashboardApp = this;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>
